<div class="content">
  <span [innerHTML]="'app.install.message' | translate"></span>
  <div class="full-width"><mat-icon>arrow_downward</mat-icon></div>
</div>
<button class="btn-close" mat-icon-button (click)="close()" aria-label="Close">
  <mat-icon>close</mat-icon>
</button>